import { getDocs, Query, query, QuerySnapshot, where } from "firebase/firestore";

import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { Doctor } from "@/features/modules/doctor/objects/Doctor";
import { doctorModel } from "@/features/modules/doctor/models/DoctorModel";
import { Employee } from "@/features/modules/employee/objects/Employee";
import { employeeModel } from "../EmployeeModel";
import { offlineModel } from "@/core/modules/offline/models/OfflineModel";
import { store } from "@/core/modules/store/module";
import { storeTypes } from "@/core/modules/store/types";
import { User } from "@/core/modules/user/objects/User";

export const getEmployeesWithFilters = async (companyId: string, branchesIds: string[]): Promise<Employee[]> => {
  try {
    const user: User = store.getters[storeTypes.getters.getUser];

    if (offlineModel.getOfflineState() === "offline") {
      if (employeeModel.offlineModuleModel === undefined) return [];
      if (user.canRead("offline") === false) throw new Error("user doesn't have offline rights");

      const documents: Employee[] = (await offlineModel.getCacheByCollection(employeeModel.offlineModuleModel)) as Employee[];
      return documents
        .filter((employee) => companyId in employee.companies)
        .filter((employee: Employee) => Object.keys(employee.branches).some((branchId: string) => branchesIds.includes(branchId)));
    }

    if (user.role?.name === "Medico") {
      const doctor: Doctor | undefined = await doctorModel.getDoctorFromUser(user.id);
      if (doctor === undefined || doctor.authorizedCompaniesIds.includes(companyId) === false)
        throw new Error(`User doesn't have rights to read company #${companyId}`);
    }

    const snapshotQuery: Query<Employee> = query(
      employeeModel.getPathReference().withConverter(employeeModel.firestoreConverter),
      where(`companies.${companyId}.id`, "==", companyId)
    );

    const snapshot: QuerySnapshot<Employee> = await getDocs(employeeModel.addReadConditionToQuery(snapshotQuery));

    if (snapshot == undefined || snapshot.empty) return [];

    return snapshot.docs
      .map((doc) => doc.data())
      .filter((employee: Employee) => Object.keys(employee.branches).some((branchId: string) => branchesIds.includes(branchId)));
  } catch (error: unknown) {
    appFaultModel.catchAppError("EmployeeModel.getEmployeesWithFilters", { companyId, branchesIds }, error);
    return [];
  }
};
